import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { TeamPositionPlayer, TeamDetailsPositions } from "./LeagueSignUp";

export default function TeamCard({
  teamMembers,
}: {
  teamMembers: TeamDetailsPositions;
}) {
  function createData(
    name: string,
    rating: number,
    position: number,
    playerIndex: number
  ) {
    return { name, rating, position, playerIndex };
  }
  const [rows, setRows] = useState<
    { name: string; rating: number; position: number; playerIndex: number }[]
  >([]);
  useEffect(() => {
    let newRows: {
      name: string;
      rating: number;
      position: number;
      playerIndex: number;
    }[] = [];
    console.log(teamMembers);
    let postion = 0;
    while (postion < Object.keys(teamMembers).length) {
      //teamMembers.map((teamMember: TeamPositionPlayers, index: number) =>
      if (postion in teamMembers) {
        const currentPosition = postion;
        teamMembers[postion].players.map(
          (player: TeamPositionPlayer, playerIndex: number) =>
            newRows.push(
              createData(
                player.PlayerName,
                player.PlayerRating,
                currentPosition,
                playerIndex
              )
            )
        );
      }
      postion++;
    }
    setRows(newRows);
  }, [teamMembers]);
  const StyledTableRow = styled(TableRow)<{ index: number }>(({ index }) => ({
    backgroundColor: index % 2 === 0 ? "#f5f5f5" : "transparent",
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  if (rows.length === 0) {
    return <div>Loading...</div>;
  }
  return (
    <TableContainer>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Position</TableCell>
            <TableCell align="right">Player Name</TableCell>
            <TableCell align="right">Rating</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            const isTeamCaptain =
              teamMembers[row.position].isTeamCaptain && row.playerIndex === 0;
            return (
              <StyledTableRow
                key={row.position + "-" + row.playerIndex}
                index={row.position}
              >
                <TableCell component="th" scope="row">
                  {row.playerIndex === 0 ? row.position + 1 : ""}
                </TableCell>
                <TableCell align="right">
                  <Box sx={{ position: "relative", display: "inline-block" }}>
                    {row.name}
                    {isTeamCaptain && (
                      <Chip
                        label="Captain"
                        color="primary"
                        size="small"
                        sx={{
                          height: "15px",
                          position: "absolute",
                          //top: -4,
                          right: -60,
                          "& .MuiChip-label": {
                            px: 1,
                            fontSize: "0.65rem",
                          },
                        }}
                      />
                    )}
                  </Box>
                </TableCell>
                <TableCell align="right">{row.rating}</TableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
